export default () => {
  return !!window.location.href.includes('blog');
};
